<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
              <b-card>
                <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                <form action="">
                  <div class="form-row mt-2">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                      <label for="report_type_id">Report Type</label>
                      <select v-model="search_data.report_type_id" v-validate="{ required: true }" class="form-control form-control-sm" name="report_type_id" id="report_type_id">
                        <option v-for="(report_type, index) in report_types" :key="index" :value="report_type.id">{{ report_type.id }} : {{ report_type.report_type_desc }}</option>
                      </select>
                    </div>
                  </div>
                  <button class="btn btn-success btn-sm mt-2" @click.prevent="search">
                    Search
                  </button>
                </form>
              </b-card>

              <b-card>
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ reports.length }}</span>
                        </div>
                        <div class="col-sm-6">
                          <router-link :to="{ name: 'reportCreate' }"
                                       class="btn btn-success float-right btn-sm mb-1 text-black" title="Upload Report"
                                       tag="a">
                            <i class="mdi mdi-plus-box-outline"></i> Upload Report
                          </router-link>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto" >
                      <table class="table table-centered table-striped">
                        <thead>
                        <tr>
                          <th>Sl</th>
                          <th>Title</th>
                          <th>File</th>
                          <th v-if="search_data.report_type_id == 1">Start Date</th>
                          <th v-if="search_data.report_type_id == 1">End Date</th>
                          <th v-if="search_data.report_type_id == 2">Month</th>
                          <th v-if="search_data.report_type_id == 2">Year</th>
                          <th v-if="search_data.report_type_id == 3">Year</th>
                          <th>Submission Date</th>
                          <th>Report Type</th>
                          <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(report, index) in reports" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ report.title }}</td>
                          <td>
                            <a :href="report.file" target="_blank">
                              {{ report.title }}
                            </a>
                          </td>
                          <td v-if="search_data.report_type_id == 1">{{ report.start_date }}</td>
                          <td v-if="search_data.report_type_id == 1">{{ report.end_date }}</td>
                          <td v-if="search_data.report_type_id == 2">{{ report.month }}</td>
                          <td v-if="search_data.report_type_id == 2">{{ report.month_year }}</td>
                          <td v-if="search_data.report_type_id == 3">{{ report.year }}</td>
                          <td>{{ report.submission_date }}</td>
                          <td>{{ report.report_type.report_type_desc }}</td>
                          <td>
                            <span>
                                             <router-link target="_blank"
                                                          :to="{ name: 'reportEdit', params: { report_id: report.id } }"
                                                          tag="a" class="action-icon" title="Update Report">
                                                <i class="mdi mdi-square-edit-outline editButton"></i>
                                            </router-link>
                                        </span>
                            <span>
                                            <a href="javascript:void(0);"
                                               class="action-icon" title="Delete Report"
                                               @click="onDelete(report.id, index)">
                                                <i class="mdi mdi-delete deleteButton"></i>
                                            </a>
                                        </span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <div v-if="loader" class="loader">Loading...</div>
                      <h5 class="text-center text-secondary" v-if="reports.length === 0 || !flag">
                        No Data Found
                      </h5>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";
    import months from "@views/asset/js/months"
    import years from "@views/asset/js/years"


    export default {
        page: {
            title: "Report List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Report List",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Report List",
                        active: true
                    }
                ],
                reports: [],
                report_types: [],
                months: months(),
                years: years(),
                search_data: {
                  report_type_id: '1'
                },
                btn_edit: false,
                flag: false,
                loader: false

            };
        },

        mounted() {
            this.getCodes();
        },
        methods: {
          search() {
            this.$validator.validate().then(valid => {
              this.flag = true
              this.loader = true
              if (valid) {
                http.post("api/report/search", this.search_data).then(response => {
                  if (!response.error) {
                    this.flag = true;
                    this.loader = false;
                    this.reports = response.data.reports;
                  }
                });
              }
            });
          },
          getCodes() {
            http.get("api/getReportCode").then(response => {
              if (!response.error) {
                let data = response.data;
                this.report_types = data.report_types;
              }
            });
          },

            onDelete(id) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/reports/" + id).then(response => {
                        this.$bvToast.toast(response.data.message, {
                            title: "Success",
                            autoHideDelay: 5000,
                            variant: "success"
                        });
                        this.search();
                    });
                }
            },
        },
    };
</script>
